module.exports = __webpack_public_path__ + "img/casino.83a80bd8.svg";